export default import.meta.ROLLDOWN_FILE_URL_1KvHKbdX3WTSSJV1kBnQ3w